SamlErrorController.$inject = ['$scope', 'company', '$stateParams', '$translate'];
export function SamlErrorController($scope, company,  $stateParams, $translate) {
  $scope.type = $stateParams.type;
  $scope.email = $stateParams.email;
  $scope.nameid = $stateParams.nameid;
  $scope.data = JSON.parse($stateParams.data);
  if ($scope.type === "unknown-error-1" || $scope.type === "unknown-error-2") {
    $scope.error = $translate.instant("saml-error/" + $scope.type); 
  } else {
    if ($scope.nameid !== $scope.email) {
      $scope.error = ' "' + $scope.nameid + '" (' + $scope.email + ") ";
    } else {
      $scope.error = ' "' + $scope.nameid + '" ';
    }
    $scope.error = $translate.instant("saml-error/authenticated/begin") + $scope.error + $translate.instant("saml-error/authenticated/end");
    $scope.error = $scope.error + $translate.instant("saml-error/" + $scope.type);
  }
}

